import { template as template_5871cbebcad348dba18e186336b69c47 } from "@ember/template-compiler";
import { service } from '@ember/service';
import { task } from 'ember-concurrency';
import TaskStatuses from 'eflex/constants/task-statuses';
import EchartsTheme from 'eflex/echarts-theme';
import Component from '@glimmer/component';
import { task as trackedTask } from 'reactiveweb/ember-concurrency';
import { waitFor } from '@ember/test-waiters';
import { clone, omit } from 'ramda';
import { fn, get } from '@ember/helper';
import EChart from 'eflex/components/e-chart';
import BiNoDataPlaceholder from 'eflex/components/bi/no-data-placeholder';
import Spinner from 'eflex/components/spinner';
export default class BiStationQualityChart extends Component {
    @service
    queryRunner;
    @service
    intl;
    @service
    router;
    getData = task({
        restartable: true
    }, waitFor(async (params)=>{
        const query = await this.queryRunner.queryWithParams.perform(params, [
            {
                $group: {
                    _id: '$location._id',
                    station: {
                        $first: {
                            $first: '$location.captions.text'
                        }
                    },
                    totalParts: {
                        $sum: 1
                    },
                    rejectCount: {
                        $sum: {
                            $cond: {
                                if: {
                                    $and: [
                                        {
                                            $gte: [
                                                '$status',
                                                TaskStatuses.REJECT_RANGE_START
                                            ]
                                        },
                                        {
                                            $lte: [
                                                '$status',
                                                TaskStatuses.REJECT_RANGE_END
                                            ]
                                        }
                                    ]
                                },
                                then: 1,
                                else: 0
                            }
                        }
                    },
                    passCount: {
                        $sum: {
                            $cond: {
                                if: {
                                    $and: [
                                        {
                                            $gte: [
                                                '$status',
                                                TaskStatuses.GOOD_RANGE_START
                                            ]
                                        },
                                        {
                                            $lte: [
                                                '$status',
                                                TaskStatuses.GOOD_RANGE_END
                                            ]
                                        }
                                    ]
                                },
                                then: 1,
                                else: 0
                            }
                        }
                    }
                }
            },
            {
                $addFields: {
                    quality: {
                        $round: [
                            {
                                $multiply: [
                                    {
                                        $divide: [
                                            '$passCount',
                                            '$totalParts'
                                        ]
                                    },
                                    100
                                ]
                            },
                            1
                        ]
                    }
                }
            },
            {
                $sort: {
                    quality: -1
                }
            }
        ]);
        const qualityData = await this.queryRunner.runQuery.perform('BuildStatuses', query);
        return {
            chartData: this.getStationQualityChartOptions(qualityData),
            exportData: ()=>clone(qualityData).map(omit([
                    '_id'
                ]), qualityData)
        };
    }));
    stationQualityData = trackedTask(this, this.getData, ()=>[
            {
                stationIds: this.args.stationIds,
                modelIds: this.args.modelIds,
                userIds: this.args.userIds,
                tags: this.args.tags,
                startDate: this.args.startDate,
                endDate: this.args.endDate,
                shiftNames: this.args.shiftNames
            },
            this.args.refresher
        ]);
    getStationQualityChartOptions(qualityData) {
        return {
            title: {
                text: this.intl.t('bi.chartName.qualitySummaryStation')
            },
            legend: {
                show: true,
                bottom: 5
            },
            tooltip: {
                trigger: 'axis'
            },
            yAxis: {
                type: 'category',
                boundaryGap: true,
                data: qualityData.map((item)=>item.station)
            },
            xAxis: [
                {
                    type: 'value',
                    max: 100,
                    interval: 10,
                    position: 'bottom',
                    axisLabel: {
                        formatter: '{value}%'
                    }
                },
                {
                    type: 'value',
                    show: false
                }
            ],
            series: [
                {
                    name: this.intl.t('bi.chartLegend.timePeriodTotalParts'),
                    data: qualityData.map((item)=>item.totalParts),
                    type: 'line',
                    xAxisIndex: 1,
                    color: EchartsTheme.colorPalette.biBlue
                },
                {
                    name: this.intl.t('bi.chartLegend.timePeriodRejects'),
                    data: qualityData.map((item)=>item.rejectCount),
                    type: 'line',
                    xAxisIndex: 1,
                    color: EchartsTheme.colorPalette.danger
                },
                {
                    name: this.intl.t('bi.chartLegend.timePeriodQuality'),
                    data: qualityData.map((item)=>item.quality),
                    type: 'bar',
                    xAxisIndex: 0,
                    color: EchartsTheme.colorPalette.success
                }
            ],
            stationIds: qualityData.map((item)=>item._id)
        };
    }
    stationDrillDown = (stationQualityData, dataIndex)=>{
        this.router.transitionTo('bi.quality.stations', {
            queryParams: {
                stationIds: [
                    stationQualityData.stationIds[dataIndex]
                ],
                modelIds: this.args.modelIds,
                userIds: this.args.userIds,
                tags: this.args.tags,
                beginDate: this.args.startDate,
                endDate: this.args.endDate,
                shiftNames: this.args.shiftNames
            }
        });
    };
    static{
        template_5871cbebcad348dba18e186336b69c47(`
    {{! template-lint-disable no-passed-in-event-handlers }}
    {{#if this.stationQualityData.isRunning}}
      <Spinner @belowSidePanel={{true}} />
    {{else if (get this.stationQualityData.value.chartData.series '0.data.length')}}
      <div class="d-flex flex-row h-100 chart-row">
        <div class="col d-flex justify-content-around">
          <EChart
            @option={{this.stationQualityData.value.chartData}}
            @exportData={{this.stationQualityData.value.exportData}}
            class="h-100 w-100 station-quality-chart"
            @onClick={{fn this.stationDrillDown this.stationQualityData.value.chartData}}
          />
        </div>
      </div>
    {{else}}
      <BiNoDataPlaceholder />
    {{/if}}
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
